export default "__VITE_ASSET__g2E_9Qae__"